/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import EditModal from '../../commonComponent/editModal'
import DeleteModal from '../../deleteComponent/deleteModal'
import Axios from 'axios';
import APP_CONSTANT from '../../../config/constants';
import FormikAddBranch from './addBranch'
import cogoToast from 'cogo-toast';

function ActionButton(props) {
    const [editModal, setEditModal] = useState(false)
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    let handleEditClose = (data) => {
        setEditModal(false)
    }
    let handleClose = () => {
        setopenBox(false)
    }
    let handleDelete = () => {
        setsuccess(true)

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNumber = localStorage.getItem('customerNo')

        Axios.delete(`${APP_CONSTANT.BASE_URL}masters/branch/${props.data.id}`, {
            data: {
                customerNumber,
                userId
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {
            if (response.data.status === 200) {
                cogoToast.success(response.data.message)
                setTimeout(() => {
                    setsuccess(false)
                    props.agGridReact.props.reload(true)
                }, 500);
            } 
        })
        // DeleteAxios({
        //     url: props.data.url,
        //     deleteItems: {
        //         ...props.data.deleteId
        //     },
        //     deleted: (data) => {
        //         if (data && data.status === 1) {
        //             setTimeout(() => {
        //                 setsuccess(false)
        //                 props.agGridReact.props.reload(true)
        //                 // window.location.reload()
        //             }, 500);
        //         }
        //     }
        // })

    }
    let handleOpenEdit = (e) => {
        setEditModal(true)
    }
    let handleOpenDelete = (e) => {
        setopenBox(true)
    }
    return (
        <>
            <Button disabled={props.data && props.data.customerNo === 0 ? true : false} onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button disabled={props.data && props.data.customerNo === 0 ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} />
            <EditModal size="mini" open={editModal} onClose={handleEditClose}>
                {/* <FormikEditBranch branchArray={props.data} handleClose={handleEditClose} /> */}
                <FormikAddBranch valuesUpdate={props.agGridReact.props} branchArray={props.data} handleClose={handleEditClose} />
            </EditModal>
        </>
    )
}

export default ActionButton
